import MolGrid, { Column } from "@moltech/molui/molgrid";
import CardSection from "../../../../../../../components/ui/card/CardSection";
import FormDatePickerFields from "../../../../../../../components/finalForms/formFields/FormDatePickerField";
import Buttons from "../../../../../../../components/ui/button/Buttons";

const ExpenseTrending = () => {
    const data = [
        { monthIn: 'Month In A', expenses: 'expenses 1' },
        { monthIn: 'Month In A', expenses: 'expenses 2' },
        { monthIn: 'Month In B', expenses: 'expenses 1' },
        { monthIn: 'Month In B', expenses: 'expenses 3' },
        { monthIn: 'Month In A', expenses: 'expenses 1' },
        { monthIn: 'Month In A', expenses: 'expenses 2' },
        { monthIn: 'Month In B', expenses: 'expenses 1' },
        { monthIn: 'Month In B', expenses: 'expenses 3' },
        { monthIn: 'Month In A', expenses: 'expenses 1' },
        { monthIn: 'Month In A', expenses: 'expenses 2' },
        { monthIn: 'Month In B', expenses: 'expenses 1' },
        { monthIn: 'Month In B', expenses: 'expenses 3' },
        { monthIn: 'Month In A', expenses: 'expenses 1' },
        { monthIn: 'Month In A', expenses: 'expenses 2' },
        { monthIn: 'Month In B', expenses: 'expenses 1' },
        { monthIn: 'Month In B', expenses: 'expenses 3' },
    ];
    return (
        <div className="row">
            <div className="scrollable-grid col-4">
                <CardSection cardTitle="Expense Trending Details">
                    <MolGrid
                        value={data}
                        grouping
                        expandableRowGroups={true}
                        paginator={false}
                        scrollable
                        scrollHeight="flex"
                        filterDisplay="row"
                        sortMode="single"
                        showGridlines
                        resizableColumns
                    // ctxMenuItems={getCtxMenuItems1}
                    >
                        <Column field="monthIn" header="Month In" grouping sortable />
                        <Column field="expenses" header="Expenses" grouping sortable />
                    </MolGrid>
                </CardSection>
            </div>
            <div className="col-8">
                <CardSection cardTitle="Expense Trending Graph Details">

                    <div className="row p-2">
                        <div className="col-4">
                            <FormDatePickerFields
                                dataField="pdtMonth"
                                // value={isMonth}
                                labelName="From :"
                                isRequired={true}
                                type="month"
                                name="From"
                                fieldSetting={{
                                    dateConfig: {
                                        displayMonthPicker: true,
                                        format: "MM yyyy"
                                    }
                                }}
                            // onChange={(dataField, value) => setIsMonth(value)}
                            />
                        </div>
                        <div className="col-4">
                            <FormDatePickerFields
                                dataField="pdtMonth"
                                // value={isMonth}
                                labelName="To :"
                                isRequired={true}
                                type="month"
                                name="From"
                                fieldSetting={{
                                    dateConfig: {
                                        displayMonthPicker: true,
                                        format: "MM yyyy"
                                    }
                                }}
                            // onChange={(dataField, value) => setIsMonth(value)}
                            />
                        </div>
                        <div className="d-flex justify-content-center button-submit col-3">
                            <Buttons
                                buttonText="Refresh"
                                buttonTypeClassName="btn blue-btn"
                                // onClick={handaleSave}
                            // isDisable={!isEditContract}
                            />

                        </div>
                    </div>
                    <div className="p-4">
                        {/* Graph Section */}
                        Graph Section
                    </div>

                </CardSection>
            </div>
        </div>
    )
}
export default ExpenseTrending;